import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children, adminOnly = false, manageUsersOnly = false }) => {
  const { isAuthenticated, isAdmin, canManageUsers, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <p>Carregando...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !isAdmin) {
    return <Navigate to="/atendimento" replace />;
  }

  if (manageUsersOnly && !canManageUsers) {
    return <Navigate to="/atendimento" replace />;
  }

  return children;
};

export default ProtectedRoute;
